var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect2, _ellipse, _g, _ellipse2, _g2, _ellipse3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyUserCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 80,
    viewBox: "0 0 108 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4863 59.25H69.7363V58V14.3832C69.7363 13.5532 69.2568 12.7978 68.5056 12.4446L54.8977 6.04722L54.3728 7.16377L54.8977 6.04722C54.3204 5.77582 53.6522 5.77582 53.0749 6.04722L53.6068 7.17845L53.0749 6.04722L39.4671 12.4446C38.7159 12.7978 38.2363 13.5532 38.2363 14.3832V58V59.25H39.4863H68.4863Z",
    fill: "#F0F0F0",
    stroke: "#C9C9C9",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8717 13.5112H67.6577V55.1191H96.8717V13.5112Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.214 13.5112H11V55.1191H40.214V13.5112Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.969 19.2691C72.969 19.0227 73.1687 18.823 73.4151 18.823H78.7198C78.9662 18.823 79.1659 19.0227 79.1659 19.2691V24.5738C79.1659 24.8202 78.9662 25.0199 78.7198 25.0199H73.4151C73.1687 25.0199 72.969 24.8202 72.969 24.5738V19.2691Z",
    fill: "#C9C9C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.363 19.2691C85.363 19.0227 85.5628 18.823 85.8091 18.823H91.1139C91.3602 18.823 91.5599 19.0227 91.5599 19.2691V24.5738C91.5599 24.8202 91.3602 25.0199 91.1139 25.0199H85.8091C85.5628 25.0199 85.363 24.8202 85.363 24.5738V19.2691Z",
    fill: "#C9C9C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4863 31.4461C72.4863 31.1997 72.686 31 72.9324 31H78.2372C78.4835 31 78.6832 31.1997 78.6832 31.4461V36.7508C78.6832 36.9972 78.4835 37.1969 78.2372 37.1969H72.9324C72.686 37.1969 72.4863 36.9972 72.4863 36.7508V31.4461Z",
    fill: "#C9C9C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.969 44.0564C72.969 43.8101 73.1687 43.6104 73.4151 43.6104H78.7198C78.9662 43.6104 79.1659 43.8101 79.1659 44.0564V49.3612C79.1659 49.6075 78.9662 49.8073 78.7198 49.8073H73.4151C73.1687 49.8073 72.969 49.6075 72.969 49.3612V44.0564Z",
    fill: "#C9C9C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.363 31.6629C85.363 31.4165 85.5628 31.2168 85.8091 31.2168H91.1139C91.3602 31.2168 91.5599 31.4165 91.5599 31.6629V36.9676C91.5599 37.214 91.3602 37.4137 91.1139 37.4137H85.8091C85.5628 37.4137 85.363 37.214 85.363 36.9676V31.6629Z",
    fill: "#C9C9C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.363 44.0564C85.363 43.8101 85.5628 43.6104 85.8091 43.6104H91.1139C91.3602 43.6104 91.5599 43.8101 91.5599 44.0564V49.3612C91.5599 49.6075 91.3602 49.8073 91.1139 49.8073H85.8091C85.5628 49.8073 85.363 49.6075 85.363 49.3612V44.0564Z",
    fill: "#C9C9C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3115 19.2691C16.3115 19.0227 16.5112 18.823 16.7576 18.823H22.0624C22.3087 18.823 22.5084 19.0227 22.5084 19.2691V24.5738C22.5084 24.8202 22.3087 25.0199 22.0624 25.0199H16.7576C16.5112 25.0199 16.3115 24.8202 16.3115 24.5738V19.2691Z",
    fill: "#C9C9C9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7053 19.2691C28.7053 19.0227 28.905 18.823 29.1514 18.823H34.4562C34.7025 18.823 34.9022 19.0227 34.9022 19.2691V24.5738C34.9022 24.8202 34.7025 25.0199 34.4562 25.0199H29.1514C28.905 25.0199 28.7053 24.8202 28.7053 24.5738V19.2691Z",
    fill: "#C9C9C9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3115 31.6626C16.3115 31.4163 16.5112 31.2166 16.7576 31.2166H22.0624C22.3087 31.2166 22.5084 31.4163 22.5084 31.6626V36.9674C22.5084 37.2138 22.3087 37.4135 22.0624 37.4135H16.7576C16.5112 37.4135 16.3115 37.2138 16.3115 36.9674V31.6626Z",
    fill: "#C9C9C9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3115 44.0562C16.3115 43.8098 16.5112 43.6101 16.7576 43.6101H22.0624C22.3087 43.6101 22.5084 43.8098 22.5084 44.0562V49.3609C22.5084 49.6073 22.3087 49.807 22.0624 49.807H16.7576C16.5112 49.807 16.3115 49.6073 16.3115 49.3609V44.0562Z",
    fill: "#C9C9C9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7053 31.6626C28.7053 31.4163 28.905 31.2166 29.1514 31.2166H34.4562C34.7025 31.2166 34.9022 31.4163 34.9022 31.6626V36.9674C34.9022 37.2138 34.7025 37.4135 34.4562 37.4135H29.1514C28.905 37.4135 28.7053 37.2138 28.7053 36.9674V31.6626Z",
    fill: "#C9C9C9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7053 44.0562C28.7053 43.8098 28.905 43.6101 29.1514 43.6101H34.4562C34.7025 43.6101 34.9022 43.8098 34.9022 44.0562V49.3609C34.9022 49.6073 34.7025 49.807 34.4562 49.807H29.1514C28.905 49.807 28.7053 49.6073 28.7053 49.3609V44.0562Z",
    fill: "#C9C9C9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5254 20.4461C45.5254 20.1997 45.7251 20 45.9715 20H61.8995C62.1459 20 62.3456 20.1997 62.3456 20.4461V23.5539C62.3456 23.8003 62.1459 24 61.8995 24H45.9715C45.7251 24 45.5254 23.8003 45.5254 23.5539V20.4461Z",
    fill: "#C9C9C9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5254 32.8401C45.5254 32.5938 45.7251 32.394 45.9715 32.394H61.8995C62.1459 32.394 62.3456 32.5938 62.3456 32.8401V35.948C62.3456 36.1943 62.1459 36.394 61.8995 36.394H45.9715C45.7251 36.394 45.5254 36.1943 45.5254 35.948V32.8401Z",
    fill: "#C9C9C9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.7476C11 11.2549 11.3994 10.8555 11.8921 10.8555H40.214V13.5113H11V11.7476Z",
    fill: "#C9C9C9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6577 10.8555H95.9796C96.4723 10.8555 96.8717 11.2549 96.8717 11.7476V13.5113H67.6577V10.8555Z",
    fill: "#C9C9C9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 88,
    height: 46,
    fill: "url(#paint0_linear_995_10456)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_995_10456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 45,
    width: 34,
    height: 35
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 62.7209,
    rx: 17,
    ry: 17.2429,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_995_10456)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.12085,
    y: 42.082,
    width: 47.9091,
    height: 44.4134,
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1311 66.2165C18.4809 66.2165 19.8004 65.8104 20.9226 65.0497C22.0448 64.2889 22.9193 63.2076 23.4356 61.9426C23.9518 60.6777 24.0865 59.2858 23.8227 57.9431C23.5588 56.6004 22.9083 55.3673 21.9534 54.3997C20.9984 53.4322 19.782 52.7736 18.458 52.5074C17.134 52.2411 15.7618 52.3792 14.5152 52.9041C13.2685 53.429 12.2034 54.3171 11.4545 55.4562C10.7056 56.5952 10.3066 57.9339 10.308 59.303C10.308 60.2115 10.4845 61.1111 10.8275 61.9503C11.1705 62.7896 11.6732 63.552 12.3069 64.1941C12.9405 64.8362 13.6928 65.3453 14.5206 65.6923C15.3483 66.0393 16.2354 66.2174 17.1311 66.2165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6268 82.8957C32.6268 74.2201 25.6916 69.5234 17.1311 69.5234C8.57067 69.5234 1.62141 74.2201 1.62141 82.8957C1.62141 82.8957 0.205238 86.7593 17.1241 86.7593C34.043 86.7593 32.6268 82.8957 32.6268 82.8957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_995_10456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 45,
    width: 34,
    height: 35
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 62.7209,
    rx: 17,
    ry: 17.2429,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_995_10456)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.8792,
    y: 42.082,
    width: 47.9091,
    height: 44.4134,
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1311 66.2165C55.4809 66.2165 56.8004 65.8104 57.9226 65.0497C59.0448 64.2889 59.9193 63.2076 60.4356 61.9426C60.9518 60.6777 61.0865 59.2858 60.8227 57.9431C60.5588 56.6004 59.9083 55.3673 58.9534 54.3997C57.9984 53.4322 56.782 52.7736 55.458 52.5074C54.134 52.2411 52.7618 52.3792 51.5152 52.9041C50.2685 53.429 49.2034 54.3171 48.4545 55.4562C47.7056 56.5952 47.3066 57.9339 47.308 59.303C47.308 60.2115 47.4845 61.1111 47.8275 61.9503C48.1705 62.7896 48.6732 63.552 49.3069 64.1941C49.9405 64.8362 50.6928 65.3453 51.5206 65.6923C52.3483 66.0393 53.2354 66.2174 54.1311 66.2165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6268 82.8957C69.6268 74.2201 62.6916 69.5234 54.1311 69.5234C45.5707 69.5234 38.6214 74.2201 38.6214 82.8957C38.6214 82.8957 37.2052 86.7593 54.1241 86.7593C71.043 86.7593 69.6268 82.8957 69.6268 82.8957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_995_10456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 45,
    width: 34,
    height: 35
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91,
    cy: 62.7209,
    rx: 17,
    ry: 17.2429,
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_995_10456)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.8792,
    y: 42.082,
    width: 47.9091,
    height: 44.4134,
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1311 66.2165C92.4809 66.2165 93.8004 65.8104 94.9226 65.0497C96.0448 64.2889 96.9193 63.2076 97.4356 61.9426C97.9518 60.6777 98.0865 59.2858 97.8227 57.9431C97.5588 56.6004 96.9083 55.3673 95.9534 54.3997C94.9984 53.4322 93.782 52.7736 92.458 52.5074C91.134 52.2411 89.7618 52.3792 88.5152 52.9041C87.2685 53.429 86.2034 54.3171 85.4545 55.4562C84.7056 56.5952 84.3066 57.9339 84.308 59.303C84.308 60.2115 84.4845 61.1111 84.8275 61.9503C85.1705 62.7896 85.6732 63.552 86.3069 64.1941C86.9405 64.8362 87.6928 65.3453 88.5206 65.6923C89.3483 66.0393 90.2354 66.2174 91.1311 66.2165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.627 82.8957C106.627 74.2201 99.6916 69.5234 91.1311 69.5234C82.5707 69.5234 75.6214 74.2201 75.6214 82.8957C75.6214 82.8957 74.2052 86.7593 91.1241 86.7593C108.043 86.7593 106.627 82.8957 106.627 82.8957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_995_10456",
    x1: 54,
    y1: 17,
    x2: 54,
    y2: 58.2083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyUserCompany);
export default __webpack_public_path__ + "static/media/survey-user-company.466fefdb03bae4a5dd702dd56de1453c.svg";
export { ForwardRef as ReactComponent };